import { useEffect, useState, useRef } from "react";
import useStyles from "./styles/navbar";
import IconButton from "@material-ui/core/IconButton";
import { Menu as MenuIcon, Person } from "@material-ui/icons";
import { useMediaQuery, useTheme } from "@material-ui/core";
import MobileMenu from "./MobileMenu";
import clsx from "clsx";
import { withTranslation } from "../../i18n";
import link from "~/static/text/link";
import { getUserData } from "../../helpers/authentication";
import { destroyUserCookie } from "../../helpers/cookie";
import Link from "next/link";
import { showLogoutModal } from "../../helpers/general";
import LanguageButtonDark from "../../components/MultipleButton/LanguageButtonDark";
import { getCFCountry } from "../../helpers/setCookie";

const logoMfs = require("../../static/new-landing-page/logo/mfs_logo_for_black.webp");
const loginIcon = require("../../static/new-landing-page/user_ic.webp");

const Navbar = ({ t, hideLanguageButton: hideLanguageButtonProp = false }) => {
    const theme = useTheme();
    const [hideLanguageButtonState, setHideLanguageButtonState] = useState(false);
    useEffect(() => {
        const cfCountry = getCFCountry();
        const isOutsideIndonesia = cfCountry && String(cfCountry).toUpperCase() !== "ID";
        setHideLanguageButtonState(!!isOutsideIndonesia);
    }, []);
    const hideLanguageButton = hideLanguageButtonProp || hideLanguageButtonState;
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const classes = useStyles();
    const [openDrawer, setOpenDrawer] = useState(false);
    const [userData, setUserData] = useState(null);
    const [showArticlesDropdown, setShowArticlesDropdown] = useState(false);
    const [showAccountDropdown, setShowAccountDropdown] = useState(false);
    const dropdownTimeoutRef = useRef(null);
    const accountDropdownTimeoutRef = useRef(null);

    const [articleDropdown] = useState([
        {
            id: "fatloss",
            link: link.mobile.articleCategory("fatloss"),
            label: "fatlossDefault",
        },
        {
            id: "workout",
            link: link.mobile.articleCategory("workouts"),
            label: "workoutDefault",
        },
        {
            id: "nutrition",
            link: link.mobile.articleCategory("nutrition"),
            label: "nutritionDefault",
        },
        {
            id: "healthy-living",
            link: link.mobile.articleCategory("healthy-living"),
            label: "healthy_livingDefault",
        },
        {
            id: "personal-development",
            link: link.mobile.articleCategory("personal-development"),
            label: "personal_developmentDefault",
        },
    ]);

    useEffect(() => {
        // Always set userData when localStorage has a profile so the topbar
        // shows the logged-in user. Avatar may be missing for fresh accounts;
        // renderAccountView handles the fallback.
        const dataUser = getUserData();
        if (dataUser) {
            setUserData(dataUser);
        }
    }, []);

    const handleOpenDrawer = () => {
        setOpenDrawer(!openDrawer);
    };

    const handleArticlesMouseEnter = () => {
        if (dropdownTimeoutRef.current) {
            clearTimeout(dropdownTimeoutRef.current);
            dropdownTimeoutRef.current = null;
        }
        setShowArticlesDropdown(true);
    };

    const handleArticlesMouseLeave = () => {
        dropdownTimeoutRef.current = setTimeout(() => {
            setShowArticlesDropdown(false);
        }, 500);
    };

    const handleDropdownMouseEnter = () => {
        if (dropdownTimeoutRef.current) {
            clearTimeout(dropdownTimeoutRef.current);
            dropdownTimeoutRef.current = null;
        }
        setShowArticlesDropdown(true);
    };

    const handleDropdownMouseLeave = () => {
        dropdownTimeoutRef.current = setTimeout(() => {
            setShowArticlesDropdown(false);
        }, 500);
    };

    const handleAccountMouseEnter = () => {
        if (accountDropdownTimeoutRef.current) {
            clearTimeout(accountDropdownTimeoutRef.current);
            accountDropdownTimeoutRef.current = null;
        }
        setShowAccountDropdown(true);
    };

    const handleAccountMouseLeave = () => {
        accountDropdownTimeoutRef.current = setTimeout(() => {
            setShowAccountDropdown(false);
        }, 500);
    };

    const handleAccountDropdownMouseEnter = () => {
        if (accountDropdownTimeoutRef.current) {
            clearTimeout(accountDropdownTimeoutRef.current);
            accountDropdownTimeoutRef.current = null;
        }
        setShowAccountDropdown(true);
    };

    const handleAccountDropdownMouseLeave = () => {
        accountDropdownTimeoutRef.current = setTimeout(() => {
            setShowAccountDropdown(false);
        }, 500);
    };

    const handleLogout = () => {
        showLogoutModal()
    };

    const handleAccountOverview = () => {
        window.location.href = link.mobile.accountOverview;
    };

    function renderAccountView() {
        if (userData) {
            return (
                <div className={classes.ctnAccount}>
                    <div
                        className={classes.ctnAvatar}
                        onMouseEnter={handleAccountMouseEnter}
                        onMouseLeave={handleAccountMouseLeave}
                    >
                        <img
                            src={(userData.avatar_thumbnails && userData.avatar_thumbnails.a)
                                || (userData.avatar_thumbnails && userData.avatar_thumbnails.default)
                                || userData.avatar_url
                                || "/static/images/default-avatar.png"}
                            alt="avatar"
                        />
                        <span className={classes.accountName}>{userData.first_name || userData.full_name || userData.email}</span>
                        {showAccountDropdown && (
                            <div
                                className={classes.accountDropdown}
                                onMouseEnter={handleAccountDropdownMouseEnter}
                                onMouseLeave={handleAccountDropdownMouseLeave}
                            >
                                <button
                                    onClick={handleAccountOverview}
                                    className={classes.dropdownItem}
                                >
                                    {t('myfitsociety:account-overview')}
                                </button>
                                <button
                                    onClick={handleLogout}
                                    className={classes.dropdownItem}
                                >
                                    {t('myfitsociety:logout')}
                                </button>
                            </div>
                        )}
                    </div>

                    <div className={classes.mobileMenu}>
                        <IconButton
                            onClick={handleOpenDrawer}
                            aria-label={openDrawer ? "Close menu" : "Open menu"}
                            className={clsx(
                                "hamburger hamburger--spin",
                                openDrawer && "is-active"
                            )}
                        >
                            <span className="hamburger-box">
                                <MenuIcon className={classes.icnStyle} />
                            </span>
                        </IconButton>
                    </div>
                </div>
            )
        }
        return (
            <div className={classes.ctnAccount}>
                <div className={classes.button}>
                    <a href={link.mobile.loginMenu} className={classes.loginButton}>
                        <img className={classes.loginIcon} src={loginIcon} alt="login" />
                        {t("mobile-landing:header_login_register")}
                    </a>
                </div>
                <a href={link.mobile.loginMenu} className={classes.userMobile} aria-label={t("mobile-landing:header_login_register")}>
                    <Person className={classes.icnUser} />
                </a>
                <div className={classes.mobileMenu}>
                    <IconButton
                        onClick={handleOpenDrawer}
                        aria-label={openDrawer ? "Close menu" : "Open menu"}
                        className={clsx(
                            "hamburger hamburger--spin",
                            openDrawer && "is-active"
                        )}
                    >
                        <span className="hamburger-box">
                            <MenuIcon className={classes.icnStyle} />
                        </span>
                    </IconButton>
                </div>
            </div>
        )
    }

    function renderMenu() {
        return (
            <>
                <a href={link.mobile.downloadAppRoot}>{t("mobile-landing:features")}</a>
                <a href={link.mobile.foodDatabase}>{t("mobile-landing:header_food_database")}</a>
                <div
                    className={classes.articlesMenuContainer}
                    onMouseEnter={handleArticlesMouseEnter}
                    onMouseLeave={handleArticlesMouseLeave}
                >
                    <a
                        href={link.mobile.articles}
                        className={classes.articlesLink}
                    >
                        {t("mobile-landing:header_articles")}</a>
                    {showArticlesDropdown && (
                        <div
                            className={classes.articlesDropdown}
                            onMouseEnter={handleDropdownMouseEnter}
                            onMouseLeave={handleDropdownMouseLeave}
                        >
                            {articleDropdown.map((c) => (
                                <a
                                    href={c.link}
                                    key={c.id}
                                    className={classes.dropdownItem}
                                >
                                    {t("myfitsociety:" + c.label)}
                                </a>
                            ))}
                        </div>
                    )}
                </div>
                <a href={link.mobile.tools}>{t("mobile-landing:header_tools_h")}</a>
            </>
        );
    }

    return (
        <>
            {isMobile && (
                <MobileMenu
                    open={openDrawer}
                    toggleDrawer={handleOpenDrawer}
                />
            )}
            <div className={classes.root}>
                <div className={classes.container}>
                    <a href={link.mobile.home}>
                        <img src={logoMfs} className={classes.logoMfs} alt="logo" />
                    </a>
                    <div className={classes.menu}>
                        {renderMenu()}
                    </div>
                    <div className={classes.ctnLanguageDesktop}>
                        {!hideLanguageButton && (
                            <div className={classes.ctnLanguage}>
                                <LanguageButtonDark />
                            </div>
                        )}
                        {renderAccountView()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTranslation(["mobile-landing", "myfitsociety"])(Navbar);
